export interface RequestLog {
  payload: any;
  responsePayload: any;
  status: string;
  statusCode: number;
  method: string;
  timestamp: string;
  serviceName: string;
  businessName: string;
  connectionId: string;
  requestId: string;
  url: string;
  userUuid: string;
  source: string;
  //   sandbox: boolean;
}
export interface RequestLogsParams {
  connectionUuid?: string;
  status?: string | number;
  method?: string;
  limit?: number;
  offset?: number;
  startDate?: string;
  endDate?: string;
}

export interface RequestLogsResponse {
  meta: any;
  data: RequestLog[];
}

export const RequestLogsStatus = {
  success: 'SUCCESS',
  failure: 'FAILURE',
};

export const RequestLogsStatusCodes = [
  'All',
  200,
  201,
  202,
  204,
  304,
  400,
  401,
  403,
  404,
  405,
  409,
  429,
  500,
];
